// TODO: tymczasowa implementacja na localStorage (BE `PUT /api/ui/sales-crm/filters/:id` nie istnieje, zwraca 404).
// Docelowo wrocic do wywolan HTTP aby presety synchronizowaly sie miedzy urzadzeniami tradera.

import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';
import {
  getSalesCrmFiltersQueryKey,
  readSalesCrmFiltersFromStorage,
  writeSalesCrmFiltersToStorage
} from 'api/endpoints/useGetSalesCrmFilters';

export interface IPutSalesCrmFiltersRequest {
  component_symbol: string;
  name?: string;
  filters: IWiseTableAdvancedFilter[];
  column_visibility?: Record<string, boolean>;
  column_order?: string[];
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmFilters = (
  id: string | number,
  data: IPutSalesCrmFiltersRequest
): Promise<IResponse> => {
  const numericId = typeof id === 'number' ? id : Number(id);
  const items = readSalesCrmFiltersFromStorage(data.component_symbol);
  const next = items.map((item) =>
    item.id === numericId
      ? {
          ...item,
          name: data.name ?? item.name,
          filters: data.filters,
          column_visibility: data.column_visibility,
          column_order: data.column_order
        }
      : item
  );
  writeSalesCrmFiltersToStorage(data.component_symbol, next);
  return Promise.resolve({
    fields_info: [],
    message: '',
    show_message: false,
    status: 1
  });
};

export const usePutSalesCrmFilters = (
  componentSymbol: string,
  options?: UseMutationOptions<IResponse, IError, { id: string | number; data: IPutSalesCrmFiltersRequest }>
) => {
  const queryClient = useQueryClient();
  return useMutation(({ id, data }) => putSalesCrmFilters(id, data), {
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(getSalesCrmFiltersQueryKey(componentSymbol));
      options?.onSuccess?.(...args);
    }
  });
};
